export const messagesI18n = {
  en: {
    common: {
      emailAddress: "Email address",
      password: "Password",
      firstName: "First name",
      lastName: "Last name",
      fullName: "Full name",
      telNumber: "Telephone number",
      buttonCancel: "CANCEL",
      buttonLogin: "LOG IN",
      forgotPassword: "Forgot your password?",
      logout: "LOG OUT",
      required: "Required",
      yen: "Yen",
      free: "Free",
      taxInclusive: "Tax-inclusive",
      untaxable: "Untaxable",
      messageErrorHasOccurred: "An error has occurred.",
      agree: "agree",  //未確定
      buttonClose: "close",
      buttonBack: "back", //未確定
      buttonSet: "set",
      privacyPolicy: "Privacy policy",
    },
    eventInfo: {
      eventName: "Event name",  //未確定
      eventOverview: "General Information",
      organizerInfo: "Organizer information",
      termDates: "Date",
      termClocks: "Event time",
      access: "Venue / Access",
      originalMap: "Map",
      googleMap: "Google Map",
    },
    registration: {
      messageRequired: "This field is required",
      messageLengthRule: "Please enter {length} characters or less",
      messagePasswordRequired: "Password is required", //未確定
      messagePasswordConfirmRequired: "Password (confirm) is required", //未確定
      messagePasswordRule: "The password must be set with mixture of alphanumeric characters and between 8 and 55 characters long.", //未確定
      messageNotMatchPassword: "Password does not match", //未確定
      messageTelNumberRequired: "This field is required",
      messageInvalidTelNumber: "Please enter in phone number format", //未確定
    },
    invitation: {
      messageThankYouForAccept: "Thank you very much for accepting the invitation to {eventName}.",
      messagePleaseAcceptAndFill: {
        preText: "Please agree to the",
        postText: "and set a new password."
      },
      messageConfirmSetNewPassword: "Do you want to set a new password?", //未確定
      messageCompleteSetNewPassword: "Your password has now been set.", //未確定
      confirmPassword: "Password (confirm)", //未確定
      messageDeadlineHasPassed: "The deadline for changing your password has passed. Please start the password change process again.", //未確定
      messageDataCantFind: "No data found.",
    },
    passwordReset: {
      messageReissueYourPassword: "We will reissue your password.", //未確定
      messageEnterYourEmailAddress: "Please enter your registered email address.", //未確定
      buttonSubmit: "send", //未確定
      linkReturnToLoginPage: "Return to login page", //未確定
      messageMailRequired: "Email address is required", //未確定
      messageMailLengthRule: "Please enter 128 characters or less", //未確定
      messageMailFormat: "Please enter in email address format.", //未確定
      messageConfirmResetPassword: "Would you like to reset your password?", //未確定
      messagePasswordResetMailSent: "An email has been sent to the email address you entered. Please click the URL to reset your password.", //未確定
      messageIncorrectEmailAddress: "The email address you entered is incorrect.", //未確定
      messagePleaseSetNewPassword: "Please set your new password。", //未確定
      confirmPassword: "Password (confirm)", //未確定
      messageConfirmSetNewPassword: "Do you want to set a new password?", //未確定
      messageCompleteSetNewPassword: "Your password has now been set.", //未確定
      messageDeadlineHasPassed: "The deadline for changing your password has passed. Please start the password change process again.", //未確定
    },
    publish: {
      toMyPage: {
        buttonLogin: "MyPage Log in",
        tooltipLogin: "If you have already registered, click here",
        dialogHeader: "MyPage Log in",
        messageInputEmail: "Please enter your email address",
        messageInputPassword: "Please enter your password",
        messageIncorrectInputs: "The email address or password is incorrect.",
        messageAccountLocked: "Your account is locked.",
        messageForgotPassword: "Please use the \"Forgot your password?\" link to reset your password."
      },
      eventStatus: {
        registrationClosed: "Registration for this event is closed.",
        registrationNotAccepting: "We do not currently accept any registration.<br />>Please contact the organizers.",
      },
      ticketStatus: {
        full: "No seats left",
        nRemains: "Seats left {n}",
        fewRemains: "A few seats left",
        available: "Available"
      },
      registration: {
        enterInfo: "Enter application information",  //未確定
        chooseCategory: "Choose category",
        fee: "fee",
        confirmMailAddress: "Email address (confirm)",  //未確定
        loginPassword: "Log in Password",
        passwordRule: {
          chars: "8 or more digits containing mixed alphanumeric characters ",
          symbols: "* Symbols cannot be used"
        },
        telNoRule: "Please enter without hyphens",
        mailMagazine: "If you would like to receive service information such as email newsletters from us in the future, please check this box.",
        buttonSubmit: "Submit",
        messageNotMatchEmail: "Email address does not match",
        messageNameLengthRule: "Please enter 128 characters or less",
        messageMailFormat: "Please enter in email address format.",
        messageConfirmRegister: "Would you like to register for this event?",
        messageCompleteRegister: "Your registration has been completed.",
        messageAlreadyRegistered: "The email address you entered has been already registered. Please log in using the login button.",
        messagePaymentProcessCompleted: "The payment process has been completed successfully.",
        messageErrorWhenPostPaymentProcess: "An error occurred during post-payment processing. We apologize for the inconvenience. Please contact the organizer.",
        messageIdentityVerificationFailed: "We were unable to make the payment due to a failure in identity verification.",
        messageSessionHasExpired: "Your session has expired. Please check your current status and try again.",
        messageEmailAlreadyExists: "The email address you entered has already been registered. Please log in using the login button.",
        messagePleaseRetryPaymentProcess: "Due to delay we are unable to process your payment. Please check the latest status and try again.",
        messageDelayedPaymentProcess: "There was a delay and we were unable to process your payment. We apologize for the inconvenience. Please check the latest status and try again.",
        messageErrorPaymentProcess: "The trouble has occurred, so we are unable to process your payment. We apologize for the inconvenience. Please contact the organizer.",
      },
      legal: {
        notationsSCTA: "Notations are based on the Specified Commercial Transaction Act",
        pleaseReferTo: {
          preText: "Please",
          linkText: "refer to",
          postText: ""
        },
        notationsReturnPolicy: "Return policy",
        personalInfo: {
          notations: "Handling of Personal Information",
          messagePleaseAgree: "Please agree to the Privacy Policy."
        },
        ifYouAgreeTickTheBox: {
          preText: "Please refer to ",
          linkText: "here",
          postText: ", and if you agree tick the box"
        },
        serviceTermsOfUse: {
          title: "Service Terms of Use",
          messagePleaseAgree: "Please agree to the terms of use"
        }
      },
      private: {
        accessToPrivate: "Access to limited-access sites",
        messageEnterPassword: "Please enter the password provided by the event organizer.",
        buttonAccess: "Access",
        messagePasswordRequired: "Password is required",
        messageIncorrectPassword: "The password is incorrect."
      },
      mailAuth: {
        messageMailSent: "A confirmation email has been sent.<br />Please click on the URL in the email to continue your registration.",
        confirmed: "Confirmed",
        buttonSendMail: "Send confirmation email",
        messageSendFailed: "Failed to send confirmation email.",
        messageTokenIsNotAvailable: "The token is not valid, please start again.",
        messageErrorHasOccurred: "An error occurred. Please try again from the beginning.",
      },
      overview: {
        onlineEvent: "Online event"  //未確定
      }
    },
    myPage: {
      title: "My Page",
      editRegisteredInfo: {
        title: "Edit profile",
        now: "your registered information",
        registrationRelated: "Reception related",
        mailMagazine: "I would like to receive service information such as email newsletters", //未確定
        changePassword: "Change password", //未確定
        buttonSave: "Save Edits", //未確定
        messageNameLengthRule: "Please enter 128 characters or less",
        messageUpdateComplete: "Registration information has been updated",
        messageUpdateFailed: "Failed to update registration information",
        noHyphen: "Without hyphens"  //未確定
      },
      messagePleaseScanTheQrCode: "Please scan the QR code at the reception",
      buttonDownloadRegistrationCertificate: "Download cert",
      buttonToOnlineEvent: "Go to event website", //未確定
      quiz: {
        title: "Quiz",
        statusEnded: "Ended"
      },
      survey: {
        title: "Survey",
        statusAnswered: "Answered",
        statusDeadlinePassed: "The deadline has passed",
      },
      sharedFile: "Shared file",
      titleTicketInfo: "Participation ticket information",
      buttonDownloadReceipt: "Download receipt",
      cancelApplication: {
        button: "Cancel application",
        messageConfirm: "Cancel the event registration",
        messageCompleted: "Event registration has been cancelled",
        messagePeriodHasPassed: "The cancellation period has passed. Please contact the organizer.",
        messageFailed: "Failed to cancellation",
      },
      sharedVideo: {
        title: "Shared video",
        playTime: "Play time"
      },
      messageCurrentlyPreparing: "We are currently preparing. Please wait until the event starts or refresh the page and try again.",
      messageFailedGetInfo: "Failed to get registration information",
      messageFailedGetOnlineEventInfo: "Failed to get online event website information" //未確定
    },
    payment: {
      fee: "fee",
      creditCard: {
        title: "Credit card payment", //未確定
        cardNumber: "Card number",
        expirationDate: "Card expiration date",
        securityCode: "Security code",
        infoToVerify: "Information to verify your identity", //未確定
        buttonSubmit: "Pay and register for this event", //未確定
        messageCardNumberRequired: "Card number is required", //未確定
        messageInvalidCardNumber: "The number of digits used in the card number is incorrect", //未確定
        messageExpirationDateRequired: "Card expiration date is required", //未確定
        messageInvalidExpirationDate: "Please specify the expiration date in MM/YY format (e.g. 05/23)", //未確定
        messageSecurityCodeRequired: "Security code is required", //未確定
        messageInvalidSecurityCode: "Security code format is invalid", //未確定
        messageFirstNameRequired: "First name is required", //未確定
        messageInvalidFirstName: "Please write your first name in English", //未確定
        messageTooLongFirstName: "First name is too long", //未確定
        messageLastNameRequired: "Last name is required", //未確定
        messageInvalidLastName: "Please write your last name in English", //未確定
        messageTooLongLastName: "Last name is too long", //未確定
        messageInvalidEmailAddress: "Please enter in email address format.", //未確定
        messageInvalidTelNumber: "Please enter in phone number format.", //未確定
        messageReturnInfoRequired: "Please enter either your phone number or email address.", //未確定
        messageFailedGetToken: "Failed to obtain token.", //未確定
        messageInvalidValues: "Payment failed. Please check your input and try again.", //未確定
        messageCardDoesNotSupportAuthentication: "This card does not support identity authentication services.", //未確定
        messageCardCanNotUsable: "The card you entered cannot be used.", //未確定
        messageCenterError: "An error has occurred. Please try again.", //未確定
        messageOtherErrors: "An error has occurred. Please try again.", //未確定
        messageFailedPaymentProcess: "An error occurred during payment processing.", //未確定
        messageFailedTDS2Token: "Failed to obtain TDS2 token.。", //未確定
        messageProcessWasAborted: "The payment process was aborted。", //未確定
        messageFailedPreparePaymentProcess: "Failed to prepare payment. Please check your input and try again.", //未確定
        messageCardIsNotSupported: "The card you entered is not supported.", //未確定
      }
    }
  },
  ja: {
    common: {
      emailAddress: "メールアドレス",
      password: "パスワード",
      firstName: "姓",
      lastName: "名",
      fullName: "姓名",
      telNumber: "電話番号",
      buttonCancel: "キャンセル",
      buttonLogin: "ログイン",
      forgotPassword: "パスワードを忘れた方はこちら",
      logout: "ログアウト",
      required: "必須",
      yen: "円",
      free: "無料",
      taxInclusive: "税込",
      untaxable: "不課税",
      messageErrorHasOccurred: "エラーが発生しました。",
      agree: "同意する",
      buttonClose: "閉じる",
      buttonBack: "戻る",
      buttonSet: "設定",
      privacyPolicy: "プライバシーポリシー",
    },
    eventInfo: {
      eventName: "イベント名",
      eventOverview: "イベント概要",
      organizerInfo: "主催者情報",
      termDates: "会期日",
      termClocks: "会期時間",
      access: "会場アクセス",
      originalMap: "オリジナルマップ",
      googleMap: "Google Map",
    },
    registration: {
      messageRequired: "必須事項です",
      messageLengthRule: "{length}文字以下で入力してください",
      messagePasswordRequired: "パスワードは必須です",
      messagePasswordConfirmRequired: "パスワード（確認）は必須です",
      messagePasswordRule: "パスワードは半角英数字を混在させた文字列を、8文字以上55文字以下で設定してください",
      messageNotMatchPassword: "入力されたパスワードが一致していません",
      messageTelNumberRequired: "TELは必須事項です",
      messageInvalidTelNumber: "電話番号のフォーマットで入力してください",
    },
    invitation: {
      messageThankYouForAccept: "この度は「{eventName}」へのご参加登録、誠にありがとうございます。",
      messagePleaseAcceptAndFill: {
        preText: "",
        postText: "に同意の上、新規パスワードを設定してください。"
      },
      messageConfirmSetNewPassword: "新しいパスワードの設定を行ってもよろしいですか？",
      messageCompleteSetNewPassword: "パスワードの設定が完了しました。",
      confirmPassword: "パスワード（確認）",
      messageDeadlineHasPassed: "パスワード変更手続きの期限が過ぎています。再度、パスワード変更手続きを開始してください。",
      messageDataCantFind: "データが見つかりませんでした",
    },
    passwordReset: {
      messageReissueYourPassword: "パスワードを再発行いたします.",
      messageEnterYourEmailAddress: "登録されているメールアドレスを入力してください。",
      buttonSubmit: "送信",
      linkReturnToLoginPage: "ログインページに戻る",
      messageMailRequired: "メールアドレスは必須です",
      messageMailLengthRule: "128文字以下にしてください",
      messageMailFormat: "メールアドレスの形式で入力を行ってください。",
      messageConfirmResetPassword: "パスワードの再発行を行ってもよろしいですか？",
      messagePasswordResetMailSent: "入力されたメールアドレスにメールを送信しました。URLをクリックしてパスワードの再設定を行ってください。",
      messageIncorrectEmailAddress: "入力されたメールアドレスが正しくありません。",
      messagePleaseSetNewPassword: "新規パスワードを設定してください。",
      confirmPassword: "パスワード（確認）",
      messageConfirmSetNewPassword: "新しいパスワードの設定を行ってもよろしいですか？",
      messageCompleteSetNewPassword: "パスワードの設定が完了しました。",
      messageDeadlineHasPassed: "パスワード変更手続きの期限が過ぎています。再度、パスワード変更手続きを開始してください。",
    },
    publish: {
      toMyPage: {
        buttonLogin: "MyPageにログイン",
        tooltipLogin: "お申込み済みの方はこちら",
        dialogHeader: "MyPageにログイン",
        messageInputEmail: "メールアドレスを入力してください",
        messageInputPassword: "パスワードを入力してください",
        messageIncorrectInputs: "メールアドレスまたはパスワードが間違っています。",
        messageAccountLocked: "アカウントがロックされています。",
        messageForgotPassword: "「パスワードを忘れた方はこちら」のリンクからパスワードリセット操作を行ってください。"
      },
      eventStatus: {
        registrationClosed: "本イベントの受付は終了いたしました。",
        registrationNotAccepting: "現在申込を受け付けておりません。<br />主催者にお問い合わせください。",
      },
      ticketStatus: {
        full: "満席",
        nRemains: "残 {n} 席",
        fewRemains: "残席が少なくなりました。お急ぎください。",
        available: "お席には余裕があります。"
      },
      registration: {
        enterInfo: "お申し込み情報入力",
        chooseCategory: "選択してください",
        fee: "参加費",
        confirmMailAddress: "メールアドレス（確認）",
        loginPassword: "ログインパスワード",
        passwordRule: {
          chars: "8桁以上の半角英数字の混在",
          symbols: "※記号は使用できません"
        },
        telNoRule: "ハイフンなしで入力してください",
        mailMagazine: "今後、弊社よりお送りさせていただくメールマガジンなどのサービス情報を希望される場合はチェックを入れてください。",
        buttonSubmit: "申し込む",
        messageNotMatchEmail: "メールアドレスが一致していません",
        messageNameLengthRule: "128文字以下で入力してください",
        messageMailFormat: "メールアドレスの形式で入力を行ってください。",
        messageConfirmRegister: "このイベントへの参加登録を行ってもよろしいですか？",
        messageCompleteRegister: "参加登録が完了しました。",
        messageAlreadyRegistered: "入力されたメールアドレスは既に登録されています。ログインボタンからログインしてください。",
        messagePaymentProcessCompleted: "決済処理が正常に完了いたしました。",
        messageErrorWhenPostPaymentProcess: "決済後の処理でエラーが発生しました。申し訳ございませんが、主催者までお問い合わせください。",
        messageIdentityVerificationFailed: "本人認証に失敗しましたため、決済することができませんでした。",
        messageSessionHasExpired: "セッションが切れました。最新の状態を確認し、再度お試しください。",
        messageEmailAlreadyExists: "入力されたメールアドレスは既に登録されています。ログインボタンからログインしてください。",
        messagePleaseRetryPaymentProcess: "問題が発生し決済することができませんでした。最新の状態を確認し、再度お試しください。",
        messageDelayedPaymentProcess: "遅延が発生し、決済することができませんでした。恐れ入りますが、最新の状態を確認し、再度お試しください。",
        messageErrorPaymentProcess: "問題が発生し決済することができませんでした。申し訳ございませんが、主催者までお問い合わせください。",
      },
      legal: {
        notationsSCTA: "特定商取引法に基づく表記",
        pleaseReferTo: {
          preText: "",
          linkText: "こちら",
          postText: "をご確認ください"
        },
        notationsReturnPolicy: "返品特約に関する表記",
        personalInfo: {
          notations: "個人情報の取り扱いについて",
          messagePleaseAgree: "個人情報の取り扱いについての同意をお願いします"
        },
        ifYouAgreeTickTheBox: {
          preText: "",
          linkText: "こちら",
          postText: "をご確認いただき、同意される場合はチェックを入れてください。"
        },
        serviceTermsOfUse: {
          title: "受付管理サービスご利用規約",
          messagePleaseAgree: "利用規約への同意をお願いします"
        }
      },
      private: {
        accessToPrivate: "限定公開サイトへアクセス",
        messageEnterPassword: "イベント主催者より伝えられたパスワードを入力してください",
        buttonAccess: "アクセス",
        messagePasswordRequired: "パスワードは必須です",
        messageIncorrectPassword: "パスワードが間違っています。"
      },
      mailAuth: {
        messageMailSent: "確認メールを送信いたしました。<br />メールに記載したURLをクリックして登録を継続してください。",
        confirmed: "確認済み",
        buttonSendMail: "確認メールを送信",
        messageSendFailed: "確認メールの送信に失敗しました。",
        messageTokenIsNotAvailable: "トークンが有効ではありません。最初からやり直してください。",
        messageErrorHasOccurred: "エラーが発生しました。恐れ入りますが、最初からやり直してください。",
      },
      overview: {
        onlineEvent: "オンライン開催"
      }
    },
    myPage: {
      title: "マイページ",
      editRegisteredInfo: {
        title: "登録情報の編集",
        now: "ご登録情報",
        registrationRelated: "受付関連",
        mailMagazine: "メールマガジンなどのサービス情報を希望する",
        changePassword: "パスワードを変更",
        buttonSave: "編集内容を保存",
        messageNameLengthRule: "128文字以下で入力してください",
        messageUpdateComplete: "登録情報を更新しました",
        messageUpdateFailed: "登録情報の更新に失敗しました",
        noHyphen: "ハイフンなし"
      },
      messagePleaseScanTheQrCode: "当日受付にて上記QRコードをかざしてください。",
      buttonDownloadRegistrationCertificate: "参加受付証ダウンロード",
      buttonToOnlineEvent: "視聴ページへ",
      quiz: {
        title: "テスト",
        statusEnded: "終了"
      },
      survey: {
        title: "アンケート",
        statusAnswered: "回答済み",
        statusDeadlinePassed: "回答締切",
      },
      sharedFile: "共有ファイル",
      titleTicketInfo: "参加券情報",
      buttonDownloadReceipt: "領収書ダウンロード",
      cancelApplication: {
        button: "申し込みをキャンセル",
        messageConfirm: "イベント申し込みをキャンセルしてもよろしいでしょうか？",
        messageCompleted: "イベント申し込みのキャンセルが完了しました",
        messagePeriodHasPassed: "キャンセル可能期間を過ぎています。主催者へお問い合わせください。",
        messageFailed: "イベント申し込みのキャンセルに失敗しました",
      },
      sharedVideo: {
        title: "共有動画",
        playTime: "再生時間"
      },
      messageCurrentlyPreparing: "ただいま準備中です。イベント開催まで待っていただくか、もしくはページを更新し、再度お試しください。",
      messageFailedGetInfo: "登録情報の取得に失敗しました",
      messageFailedGetOnlineEventInfo: "視聴ページ情報の取得に失敗しました"
    },
    payment: {
      fee: "参加費",
      creditCard: {
        title: "クレジットカード決済",
        cardNumber: "カード番号",
        expirationDate: "有効期限",
        securityCode: "セキュリティコード",
        infoToVerify: "本人確認のための情報",
        buttonSubmit: "支払をし、このイベントに申し込む",
        messageCardNumberRequired: "カード番号は必須です",
        messageInvalidCardNumber: "カード番号に使用されている数字または桁数が違います",
        messageExpirationDateRequired: "有効期限は必須です",
        messageInvalidExpirationDate: "有効期限は MM/YY の形式でご指定ください（例：05/23）",
        messageSecurityCodeRequired: "セキュリティコードは必須です",
        messageInvalidSecurityCode: "セキュリティコードの形式が不正です",
        messageFirstNameRequired: "姓（半角英字）は必須です",
        messageInvalidFirstName: "請求先名前（姓）は半角英字で記入してください",
        messageTooLongFirstName: "請求先名前（姓）が長過ぎます",
        messageLastNameRequired: "名（半角英字）は必須です",
        messageInvalidLastName: "請求先名前（名）は半角英字で記入してください",
        messageTooLongLastName: "請求先名前（名）が長過ぎます",
        messageInvalidEmailAddress: "メールアドレスの形式で入力を行ってください。",
        messageInvalidTelNumber: "電話番号の形式で入力を行ってください。",
        messageReturnInfoRequired: "電話番号またはメールアドレスのどちらかをご入力ください。",
        messageFailedGetToken: "トークン取得に失敗しました。",
        messageInvalidValues: "決済に失敗しました。入力内容をお確かめのうえ、再度お試しください。",
        messageCardDoesNotSupportAuthentication: "本人認証サービスに対応していないカードです。",
        messageCardCanNotUsable: "ご入力いただいたカードは使用いただけません。",
        messageCenterError: "エラーが発生しました。恐れ入りますが再度お試しください。",
        messageOtherErrors: "エラーが発生しました。恐れ入りますが再度お試しください。",
        messageFailedPaymentProcess: "決済処理でエラーが発生しました。",
        messageFailedTDS2Token: "TDS2トークン取得に失敗しました。",
        messageProcessWasAborted: "決済処理が中断されました。",
        messageFailedPreparePaymentProcess: "決済の準備に失敗しました。入力内容をお確かめのうえ、再度お試しください。",
        messageCardIsNotSupported: "ご入力いただいたカードは対応しておりません。",
      }
    }
  }
}
